import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save } from "lucide-react";

interface MediaDialogFooterProps {
  inkCost: number;
  certificateCost: number;
  cutCost: number;
  onInkCostChange: (value: number) => void;
  onCertificateCostChange: (value: number) => void;
  onCutCostChange: (value: number) => void;
  onSave: () => void;
  isPending: boolean;
}

export function MediaDialogFooter({
  inkCost,
  certificateCost,
  cutCost,
  onInkCostChange,
  onCertificateCostChange,
  onCutCostChange,
  onSave,
  isPending,
}: MediaDialogFooterProps) {
  return (
    <div className="space-y-4 mt-4">
      <div className="flex items-center gap-4">
        <div className="flex items-center space-x-2">
          <Label htmlFor="ink-cost">Ink Cost ($)</Label>
          <Input
            id="ink-cost"
            type="number"
            value={inkCost}
            onChange={(e) => onInkCostChange(parseFloat(e.target.value) || 0)}
            className="w-24"
            min={0}
            step={0.01}
          />
        </div>
        <div className="flex items-center space-x-2">
          <Label htmlFor="certificate-cost">Certificate Cost ($)</Label>
          <Input
            id="certificate-cost"
            type="number"
            value={certificateCost}
            onChange={(e) => onCertificateCostChange(parseFloat(e.target.value) || 0)}
            className="w-24"
            min={0}
            step={0.01}
          />
        </div>
        <div className="flex items-center space-x-2">
          <Label htmlFor="cut-cost">Cut Cost ($)</Label>
          <Input
            id="cut-cost"
            type="number"
            value={cutCost}
            onChange={(e) => onCutCostChange(parseFloat(e.target.value) || 0)}
            className="w-24"
            min={0}
            step={0.01}
          />
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={onSave} disabled={isPending}>
          <Save className="mr-2 h-4 w-4" />
          Save Settings
        </Button>
      </div>
    </div>
  );
}